// extracted by mini-css-extract-plugin
module.exports = {"container":"_1yUjrQrhDxT0PBpTmsWQIw"};